import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { BrowserRouter as Router } from 'react-router-dom';
import { GoogleOAuthProvider } from '@react-oauth/google';

// Suppress browser console output in production builds
if (import.meta.env.PROD) {
  const suppressConsoleOutput = () => {};
  console.log = suppressConsoleOutput;
  console.warn = suppressConsoleOutput;
  console.error = suppressConsoleOutput;
}

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <GoogleOAuthProvider clientId={process.env.REACT_APP_GOOGLE_CLIENT_ID!}>
      <Router>
    <App />
  </Router>
    </GoogleOAuthProvider>
  
);

reportWebVitals();
